class declareDetailRootCtrl {
    constructor($rootScope, $scope, httpRequest) {
        // 用户信息
        const { userInfo } = $rootScope
        // 存储页面信息
        $scope.pageState = {
            idToken: $rootScope.idToken,
            userInfo,
        }
        // 字典数据
        $scope.dictData = {}
        $scope.dictDataSel = {}
        const typecodeArrStr = '["ivat_inv_type","back_status","apply_way","operate_status","devision_status","stock_inv_type","back_type"]'
        const typecodeArr = ['ivat_inv_type', 'back_status', 'apply_way', 'operate_status', 'devision_status', 'stock_inv_type', 'back_type']
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
            for (let i = 0, l = typecodeArr.length; i < l; i++) {
                const arr = $scope.dictData[typecodeArr[i]]
                arr.push({ enumTypeCode: null, enumName: '无', enumCode: '' })
                arr.reverse()
                $scope.dictData[typecodeArr[i]] = arr.slice()
                $scope.dictDataSel[typecodeArr[i]] = JSON.parse((JSON.stringify($scope.dictData[typecodeArr[i]])))
                $scope.dictDataSel[typecodeArr[i]][0].enumName = '全部'
            }
        })
    }
}
declareDetailRootCtrl.$inject = ['$rootScope', '$scope', 'httpRequest']
export default declareDetailRootCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/details/declareDetailRootCtrl.js